import * as WidgetActions from '../../layers/widget/actions';
import IPC from '../../../helpers/ipc';
import Logger from '../../../../common/logger';
import Tracker from '../../../genesys/tracker';
import { WIDGET_ACTIONS, COOKIES } from '../../layers/widget/types';
import { VIEWS } from '../../views/types';

export const showCallNumber = () => {
    Logger.log('ContactActions: showCallNumber');
    Tracker.showPhoneNumber();
};

export function call(number) {
    Logger.log('ContactActions: call');
    Tracker.acceptCallInvite();
    IPC.sendEvent(WIDGET_ACTIONS.CALL, number.replace(/_| /g, ''));
}

export function callMeBack() {
    Logger.log('ContactActions: cmb');
    Tracker.acceptCallbackInvite();
    WidgetActions.onSwitchView({
        view: VIEWS.CMB
    });
}

export function chat(category, config) {
    Logger.log('ContactActions: chat');

    IPC.sendEvent(WIDGET_ACTIONS.OPEN_CLOSER_CHAT, {
        ...(category && { tags: [category] }),
        genesysConfig: config
    });

    // Tracker.acceptChatInvite();
    // WidgetActions.onSwitchView({
    //     view: VIEWS.CHAT
    // });
}

export const setDisablingProactiveCookie = () => {
    IPC.sendEvent(COOKIES.SET_DISABLING_PROACTIVE_COOOKIE);
};
